import Vue from 'vue';
import Router from 'vue-router';

import Home from '../pages/Home';
import Select from '../pages/Select';
import Write from '../pages/Write';
import Level from '../pages/Level';
import Learn from '../pages/Learn';

Vue.use(Router);

const router =  new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/level/:route',
            name: 'level',
            component: Level,
        },
        {
            path: '/select/:id',
            name: 'select',
            component: Select,
        },
        {
            path: '/write/:id',
            name: 'write',
            component: Write,
        },
        {
            path: '/learn/:id',
            name: 'learn',
            component: Learn,
        }

    ]
});

export default router;